import React from 'react';
import { DownloadLink, GeneratedQuestion } from './models';
import { useAnalytics } from '@/app/context/AnalyticsContext/useAnalytics';
import { StaticImageData } from 'next/image';
import Image from 'next/image';

interface IProps {
  title: string;
  displayImage: StaticImageData;
  totalQuestions?: number;
  previewQuestions: GeneratedQuestion[];
  downloadLinks: DownloadLink[];
  displayImageWidth: number;
  displayImageHeight: number;
}

export default function Example(props: IProps) {
  const { trackEvent, analyticsInstance } = useAnalytics();

  const remainingQuestions = props.totalQuestions
    ? props.totalQuestions - props.previewQuestions.length
    : 0;

  const onDownladClick = () => {
    trackEvent(analyticsInstance, 'examples_click_download', {
      title: props.title
    });
  };

  return (
    <div>
      <h1 className="my-2 mb-6 w-full px-5 text-center text-3xl font-bold leading-tight text-gray-800">
        {props.title}
      </h1>
      <div className="flex flex-wrap">
        <div className="bordered w-full border border-solid border-gray-100 p-6 sm:w-1/2">
          <Image alt="example image" src={props.displayImage} />
        </div>
        <div className="w-full pl-6 pr-6 sm:w-1/2">
          <p className="text-xl font-bold text-base-content underline">
            Generated Flashcards
          </p>
          {props.previewQuestions.map((q) => (
            <p key={q.question} className="my-2 text-gray-800">
              {q.question}
              <br />
              <b>{q.answer}</b>
            </p>
          ))}
          {remainingQuestions > 0 && (
            <p className="my-2 text-base-content">
              and {remainingQuestions} more....
            </p>
          )}
        </div>
      </div>
      <div className="border-1 my-4 rounded border border-solid bg-gray-100 p-2">
        {props.downloadLinks.map((d) => (
          <h1
            key={d.url}
            className="my-2 w-full px-5 text-center text-gray-800"
          >
            Try downloading the original{' '}
            <a
              href={d.url}
              onClick={onDownladClick}
              className="text-blue"
              download
            >
              {d.fileDescription}
            </a>{' '}
          </h1>
        ))}
      </div>
    </div>
  );
}
